import * as React from "react";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {BackButton} from "../../../../../components/navigation/BackButton";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import {getSessionStorage} from "../../../../../CommonFunctions";
import {Button} from "reactstrap";
import {CLAIM_TYPE_HOME, FalconNavigatorHeader, IFalconConvenienceApiService, Types} from "@falcon/services";
import {AllianzOnlineBadge} from "../../../../../components/AllianzOnlineBadge";
import {IWithRouterProps, withRouter} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import * as moment from "moment";

interface IPageParams {
    policyNumber: string;
    [key: string]: string | undefined;
}

interface IState {
    allianzEmergencyClaimUrlDate?: moment.Moment
}

export class ClaimDetailsPagePlain extends React.Component<IWithRouterProps<IPageParams>, IState> {

    @lazyInject(Types.FalconConvenienceApiService)
    private readonly falconConvenienceApiService: IFalconConvenienceApiService

    public async componentDidMount(): Promise<void> {
               this.falconConvenienceApiService
                   .getSettings()
                   .subscribe((settings: any): void => {
                       if (settings?.allianz_emergency_claim_url_date) {
                           this.setState({
                               allianzEmergencyClaimUrlDate: moment(settings.allianz_emergency_claim_url_date)
                           });
                       }
                   });
           }

    public render() {
        const claim: string = getSessionStorage("claim");
        const referrerJourney: string = getSessionStorage("referrerJourney");
        const backLink: string = referrerJourney === 'newClaim'
            ? `/dashboard/annualHome/${this.props.params.policyNumber}/claims/new`
            : `/dashboard/annualHome/${this.props.params.policyNumber}`;
        const claimTitle = (claim === CLAIM_TYPE_HOME)
            ? "Home Emergency Claim Reporting"
            : "All other home claims";
        const hideOnlineClaims: boolean = process.env.REACT_APP_HOME_HIDE_ONLINE_CLAIMS ? (process.env.REACT_APP_HOME_HIDE_ONLINE_CLAIMS.toString() === "true") : false;
        return (
            <React.Fragment>
                <FalconHeader/>
                <div className="page-contents dashboard-page">
                    <AllianzOnlineBadge/>
                    <FalconNavigatorHeader
                        back={backLink}
                        title={claimTitle}
                    />
                    <div className="panel claim-page">
                        <div className="my-4 font-weight-bold claim-text">
                            {claim === CLAIM_TYPE_HOME
                                ? this.renderHomeEmergencyClaimContent(hideOnlineClaims)
                                : this.renderOtherClaimContent(hideOnlineClaims)
                            }

                            <p>
                                Lines open <span className="font-weight-semi-bold">24 hours, 7 days a week.</span>{' '}
                                Calls will be recorded. For Text Phone, first dial 18001
                            </p>
                        </div>
                        <BackButton isTop={false}
                                    link={backLink}/>
                    </div>
                </div>
                <FalconFooter/>
            </React.Fragment>
        );
    }

    private renderHomeEmergencyClaimContent(hideOnlineClaims: boolean): React.ReactNode {
        if (hideOnlineClaims) {
            return (
                <>
                    <p>To report a home emergency claim get in touch with us.
                    </p>
                    <p className="mt-4">Our 24 hour helpline</p>
                    <a href="tel:+44 0330 678 5239"
                       className="no-underline font-weight-semi-bold icon-phone-before"
                       id="claimsPagePhoneLinkAbroad" aria-label="Phone number +44 0330 678 5239">
                        0330 678 5239
                    </a>
                </>
            )
        } else {
            return (
                <>
                    <p>To report a home emergency claim get in touch with us.
                        You can log a claim online by using the button below. It’s simple and quick!
                    </p>
                    <Button className="my-3" color="btn btn-primary"
                            href={`${
                                this.state?.allianzEmergencyClaimUrlDate?.isSameOrBefore(moment().startOf("day"))
                                    ? process.env.REACT_APP_HOME_ALLIANZ_EMERGENCY_CLAIM_URL
                                    : process.env.REACT_APP_HOME_EMERGENCY_CLAIM_URL
                            }`}>Log a Home Emergency
                        claim</Button>
                    <p className="mt-4">Or call us on our 24 hour helpline</p>
                    <a href="tel:+44 0330 678 5239"
                       className="no-underline font-weight-semi-bold icon-phone-before"
                       id="claimsPagePhoneLinkAbroad" aria-label="Phone number +44 0330 678 5239">
                        0330 678 5239
                    </a>
                </>)
        }
    }

    private renderOtherClaimContent(hideOnlineClaims: boolean): React.ReactNode {
        if (hideOnlineClaims) {
            return (
                    <a href="tel:0330 678 5015"
                       className="no-underline font-weight-semi-bold icon-phone-before"
                       id="claimsPagePhoneLink"
                       aria-label="Phone number 0330 678 5015">
                        0330 678 5015
                    </a>
            )
        } else {
            return (
                <>
                    <p>It’s simple and quick to report a home claim using the button below.
                        Log your claim by 3pm (Mon-Fri) and we’ll reply by the end of the day or by the end of the next
                        working day if logged later.
                        Sometimes in extreme weather and busy time it can take a little longer - please bear with us!
                    </p>
                    <Button className="my-3" color="btn btn-primary"
                            href={`${process.env.REACT_APP_HOME_OTHER_CLAIM_URL}` + '?journey=digital&policy=' + `${this.props.params.policyNumber}`}>Log
                        a Home claim</Button>
                    <p className="mt-4">If it’s urgent, just give us a call</p>
                    <a href="tel:0330 678 5015"
                       className="no-underline font-weight-semi-bold icon-phone-before"
                       id="claimsPagePhoneLink"
                       aria-label="Phone number 0330 678 5015">
                        0330 678 5015
                    </a>
                </>
            )
        }
    }
}

export const ClaimDetailsPage = withRouter<{}, IPageParams>(ClaimDetailsPagePlain)
